(() => {
    "use strict"

    if (document.getElementById('locations-carousel')) {
        new Splide('#locations-carousel', {
            perPage: 1,
            perMove: 1,
            autoplay: false,
            pagination: false,
        })
        .mount()
    }
})()